import { render, staticRenderFns } from "./pickbox_bets.vue?vue&type=template&id=361e0c0e&scoped=true&"
import script from "./pickbox_bets.vue?vue&type=script&lang=js&"
export * from "./pickbox_bets.vue?vue&type=script&lang=js&"
import style0 from "./pickbox_bets.vue?vue&type=style&index=0&id=361e0c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e0c0e",
  null
  
)

export default component.exports